module.exports = PaypalSitewideSearch;


//////////////////
// WEBPACK FOOTER
// external "PaypalSitewideSearch"
// module id = 881
// module chunks = 0